import type { ReOSRepository } from "./repository";
import type { ListingDraftUpdate, Marketplace, ReOSDatabase } from "./types";

// Chain against the returned snapshot: the editor's store closure predates creation.
export async function savePreparedListing(repository: Pick<ReOSRepository, "createListingDrafts" | "updateListingDraft">, database: ReOSDatabase,
  itemID: string, marketplace: Marketplace, update: ListingDraftUpdate, listingID: string | undefined, apply: (database: ReOSDatabase) => Promise<void>) {
  let current = database;
  let id = listingID;
  if (!id) {
    const created = await repository.createListingDrafts(current, itemID, [marketplace]);
    current = created.database;
    id = created.listings[0]?.id;
    if (!id) throw new Error("The draft was not returned. Refresh the review before trying again.");
  }
  let result;
  try {
    result = await repository.updateListingDraft(current, id, update);
  } catch (error) {
    if (current !== database) await apply(current);
    throw error;
  }
  await apply(result.database);
  return result.listing;
}
